<template>
  <div>
   
    <autoLogout />
    <loader :loader="sending" />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" />
      <v-card>
        <validation-observer ref="form" v-slot="{ invalid }">
          <v-form @submit.prevent="add">
            <div class="container">
              <v-row>
                <v-col>
                  <h3 class="font-weight-black mb-5">Logos</h3>
                </v-col>
              </v-row>
              <v-row>
                <template>
                  <div class="container" >
                    <div class="d-flex justify-center">
                      <v-col class="col-md-6 col-sm-12 col-xs-12  d-flex justify-space-around">
                          <v-btn  color="primary"  text @click="dialogLogo = true"  outlined>
                              Agregar logo
                            <v-icon right>mdi-message-image-outline</v-icon>
                          </v-btn>
                      </v-col>
                      <v-col class="col-md-6 col-sm-12 col-xs-12 d-flex justify-space-around">
                            <v-btn  color="red" text @click="saveDeleteLogos()" :height="idsToDelete.length > 0 ? 45 : ''">
                              <v-row class="d-flex flex-column">
                                <v-col class="pa-0"> 
                                  Eliminar logos(s)
                                  <v-icon left>mdi-delete-empty</v-icon>
                                </v-col>
                                <v-col v-if="idsToDelete.length>0" class="pa-0">
                                  <span >{{idsToDelete.length}}</span>
                                </v-col>
                              </v-row>
                            </v-btn>
                      </v-col>
                    </div>
                  </div>
                  
                  <v-row class="col-12">
                    <v-col
                      v-for="(logo, index) in logosList"
                      :key="index"
                      class="d-flex child-flex"
                      cols="12"
                      sm="6"
                      md="3"
                      xl="2"
                    >
                      <v-card hover class="mx-auto d-flex flex-column">
                        <div class="d-flex flex-column justify-center">
                          <v-card-actions>
                            <!-- <span>{{ logo.orden == 1? "Logo derecho": logo.orden == 2 ? "Logo izquierdo":"" }}</span>  -->
                             <template>
                              <v-container fluid>
                                <v-row align="center">
                                  <v-col
                                    class="d-flex"
                                    cols="12"
                                    sm="12"
                                  >
                                    <v-select
                                      v-model="logo.orden"
                                      :items="positionList"
                                      :text="positionList.text"
                                      :value="positionList.value"
                                      label="Posición"
                                      no-data-text="Sin resultados"
                                    ></v-select>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </template> 
                            <v-spacer></v-spacer>
                            <div class="d-flex justify-end">
                              <v-checkbox
                                v-model="logo.selected"
                                label=""
                                color="success"
                                hide-details
                                @click="selectImage(logo)"
                                :disabled="!logo.orden"
                              ></v-checkbox>
                            </div>
                            
                          </v-card-actions>

                          <v-img
                            :src="'data:image/jpg;base64,' + logo.logo"
                            :lazy-src="logo.logo"
                            class="grey lighten-2"
                          >
                            <template v-slot:placeholder>
                              <v-btn
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"
                                ></v-progress-circular>
                              </v-btn>
                            </template>
                          </v-img>
                           
                        </div>
                        
                        <v-spacer></v-spacer>
                        <div align="center">
                          <v-card>
                            <v-btn icon @click="openDialogDelete(logo,index)">
                             <v-icon color="error">
                                mdi-delete 
                              </v-icon>
                            </v-btn>
                          </v-card>
                        </div>
                      </v-card>
                      
                    </v-col>
                  </v-row>
                </template>
              </v-row>
              <v-row >
                <v-col align="center">
                  <h3 class="font-weight-black mb-5">Plantillas</h3>
                </v-col>
              </v-row>
              <v-row justify="center">
                
                <v-col class="col-md-4 col-sm-12">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Descripción"
                    rules="required|max:300"
                  >
                    <v-autocomplete
                      v-model="model.template"
                      :items="templates"
                      :item-text="templates.text"
                      :item-value="templates.value"
                      :error-messages="errors"
                      label="Plantillas"
                      return-object
                      required
                      @change="changeLogoSelected(model)"
                    ></v-autocomplete>
                  </validation-provider>
                </v-col>
                
              </v-row>
              
            </div>
            <div class="d-flex justify-center">
              <v-col class="d-flex justify-space-around">
                <v-btn color="primary"  outlined
                  type="submit"
                  :disabled="
                    sending || invalid 
                  "
                 
                >
                  <v-icon left>{{ iconoAdd }}</v-icon>
                  {{ textoAdd }}
                </v-btn>
              </v-col>
            </div>
          </v-form>
        </validation-observer>
      </v-card>
    </div>
    <v-dialog v-model="dialogLogo" max-width="450">
      <v-card>
        <v-card-title class="text-h6 text-center"> Agregar logos </v-card-title>
        <v-card-text>
          <v-col>
            <v-file-input
              v-model="logos"
              multiple
              placeholder="Agregar logo"
              accept="image/png, image/jpeg, image/jpg"
              label="Agregar logo"
            ></v-file-input>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogLogo = false">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="
              dialogLogo = false;
              addLogo();
            "
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogQuestion" persistent max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            ¿Desea eliminar el logo?
          </v-card-title>

          <v-card-text v-if="logosInTemplates.length>0">
             <strong>La eliminación de el logo seleccionado afectará a los siguientes reportes vinculados. </strong>
             <ul>
               <li v-for="(item, index) in logosInTemplates" :key="item.idTemplateHtml"
                        :id="index"> {{item.name}}</li>
             </ul>
            <!--<strong>Pregunta: </strong> {{ question.name }}-->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialogQuestion = false">
              Cancelar
            </v-btn>
            <v-btn color="primary" text @click="confirmDeleteLogo()">
              Sí, eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>
<script>
import Datatable from "../../components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../../components/Sidebar";
import BtnAccion from "../../components/btnAccion.vue";
import { TemplateRequest, EnumRequest } from "@/core/request";
import { required, max } from "vee-validate/dist/rules";
import AutoLogout from "../../components/AutoLogout.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions } from "vuex";
import Loader from "../../components/Loader.vue";

export default {
  name: "Logos",
  components: {
    Sidebar,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    Datatable,
    BtnAccion,
    AutoLogout,
    Loader,
  },
  data() {
    return {
      search: "",
      model: {},
      encabezado: {
        icono: "mdi-image",
        texto: "Logos",
      },
      sending: false,
      dialogQuestion: false,
      dialogs: {
        title: "¿Desea cambiar el estatus de la especialidad?",
        text: "La especialidad será habilitada / inhabilitada de inmediato y podría afectar a los registros que dependan de ella",
      },
      headers: [
        { text: "ID Especialidad", value: "idSpeciality" },
        { text: "Nombre", value: "name" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      btnAdd: {
        icon: "mdi-plus",
        text: "Agregar Especialidad",
        tooltip: "Agregar Especialidad",
      },
      iconoAdd: "mdi-plus",
      textoAdd: "Guardar",
      service: TemplateRequest,
      templates: [],
      logos: [],
      logoDelete:{},
      dialogLogo: false,
      logosList: [],
      logosSelected: [],
      maxLogoSelected: 2,
      minLogoSelected: 1,
      positionList:[],
      disabledButtonAdd: true,
      deleteLogo:{},
      idsToDelete:[],
      logosInTemplates:[],
      indexDeleteLogo:null,
    };
  },
  created() {},
  mounted() {
    this.validBrowserTab();
    this.getlogos();
    this.getOrderLogos();
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    catchError: (e) => {
      //console.log(e);
      this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
    },
    getTemplates() {
      TemplateRequest.listAllTemplate().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.templates = res.data.data.map((template) => {
            return {
              value: template.idTemplateHtml,
              text: template.name,
              logoTemplateList: template.logoTemplateList,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      })
    },
    getOrderLogos() {
      EnumRequest.listAllOrderLogos().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.positionList = res.data.data.map((p) => {
            return {
              value: p.value,
              text: p.text,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    getlogos() {
      TemplateRequest.listLogos()
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.logosList = res.data.data.map((logo) => {
              logo.selected = false;
              logo.orden="";
              return logo;
            });
          }
        })
        .finally(() => {
          this.getTemplates();
        });
    },
    add() {
      let list = this.logosList.filter((item) =>{
        return item.selected
      }).map((item) => {
            return {
              idLogo: item.idLogo,
              orden: item.orden,
            };
      });
      const uniqueValue= [];
      let duplicateOrden = false;
      for(let i=0; i < list.length; i++){
        const elemento = list[i].orden;
        if(!uniqueValue.includes(list[i].orden)){
          uniqueValue.push(elemento);
        }else{
          duplicateOrden = true;
        }
      }

      if(duplicateOrden){
        this.$utilFront.notifications(
              "Posición del logo no puede repetirse",
              "ERROR"
            );
      }else{
        let postData = {
        logoList: list,
        idTemplateHtml: this.model.template.value,
      };
      this.sending = true;
      TemplateRequest.addLogoTemplate(postData)
        .then((res) => {
          if (res.data.code === 200 && res.data.data === true) {
            this.$utilFront.notifications(
              "Logos actualizados correctamente",
              "SUCCESS"
            );
            this.getTemplates();
            //this.changeAction(1);
          } else if (res.data.code === 401) {
            this.unauthorized();
          } else {
            this.$utilFront.notifications(res.data.message, "ERROR");
          }
        })
        .finally(() => {
          this.sending = false;
        });
      }
      
    },

    getBase64(file) {
      return new Promise((resolve, reject) => {
        try {
          let reader = new FileReader();
          reader = new FileReader();
          let fileByte = [];
          reader.readAsArrayBuffer(file);
          reader.onload = (evt) => {
            if (evt.target.readyState == FileReader.DONE) {
              let arrayBuffer = evt.target.result,
                array = new Uint8Array(arrayBuffer);
              for (let byte of array) {
                fileByte.push(byte);
              }
            }
            let f = {
              logo: fileByte,
            };
            resolve(f);
          };
          reader.onerror = function (error) {};
        } catch (e) {
        } finally {
        }
      });
    },
    async addLogo() {
      this.sending = true;
      const logosList = [];
      if (this.logos != null && this.logos.length != 0) {
        for (let logo of this.logos) {
          const value = await this.getBase64(logo);
          logosList.push(value);
        }
      }
      TemplateRequest.addLogos({ logoList: logosList })
        .then((res) => {
          if (res.data.code === 200 && res.data.data == true) {
            this.$utilFront.notifications(
              "Logos registrados correctamente",
              "SUCCESS"
            );
            this.getlogos();
          } else if (res.data.code === 401) {
            this.unauthorized();
          }else{
            this.$utilFront.notifications(
              "Error al registrar logos",
              "ERROR"
            );
          }
        })
        .finally(() => {
          this.sending = false;
          this.logos=[];
        });
    },
    selectImage() {
      let numberOfElements = 0;
      this.logosList.filter((item) => {
        if(item.selected){
          numberOfElements++;
          return {
            idLogo: item.idLogo,
            orden: item.orden,
          };
        }
      });
      // if(numberOfElements > this.maxLogoSelected){
      //   this.disabledButtonAdd = true;
      // }else if(numberOfElements == this.maxLogoSelected){
      //   this.disabledButtonAdd = false;
      // }else if(numberOfElements < this.minLogoSelected){
      //   this.disabledButtonAdd = true;
      // }
    },
    changeLogoSelected(model) {
      //this.logosSelected = [];
      if (model.template.logoTemplateList != null) {
        this.logosList.map((logo) => {
          logo.selected = false;
          logo.orden = "";
        });
        model.template.logoTemplateList.forEach((element) => {
          let i = this.logosList.findIndex(
            (index) => index.idLogo === element.logo.idLogo
          );
          this.logosList[i].selected = true;
          this.logosList[i].orden = element.orden;
        });
      } else {
        this.logosList.map((l) => {
          l.selected = false;
          l.orden = "";
        });
      }
      this.selectImage();
    },
     openDialogDelete(logo,index) {
      this.indexDeleteLogo=index;
      this.dialogQuestion = true;
      this.logoDelete=logo;
       let postData = {
          idLogo:  this.logoDelete.idLogo
        };
        TemplateRequest.templatesByLogo(postData)
        .then((res) => {
          if (res.data.code === 200) {
            this.logosInTemplates=res.data.data;
           } else if (res.data.code === 401) {
            this.unauthorized();
          }else{
            this.$utilFront.notifications(
              "Error consultar plantillas relacionadas",
              "ERROR"
            );
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },confirmDeleteLogo(){
      this.dialogQuestion = false;
      this.deleteLogo={logo:this.logoDelete,index:this.indexDeleteLogo};
      this.logosList.splice(this.indexDeleteLogo, 1);
      this.idsToDelete.push(this.logoDelete.idLogo);
    
      },saveDeleteLogos(){
         let postData = {
          idsToDelete:  this.idsToDelete
        };
        
        TemplateRequest.deleteLogo(postData)
        .then((res) => {
          if (res.data.code === 200) {
            this.$utilFront.notifications(
              this.idsToDelete.length>0?"Logos Eliminados":"Sin logos a eliminar",
              this.idsToDelete.length>0?"SUCCESS":"WARNING"
            );
          } else if (res.data.code === 401) {
            this.unauthorized();
          }else{
            this.$utilFront.notifications(
              "Error al registrar logos",
              "ERROR"
            );
          }
        })
        .finally(() => {
          this.sending = false;
          this.getlogos();
          this.idsToDelete=[];
        });
      }
  },
};
</script>